/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_BedsInputs */

const en_field_beds = /** @type {(inputs: Field_BedsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beds`)
};

const es_field_beds = /** @type {(inputs: Field_BedsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Camas`)
};

const fr_field_beds = /** @type {(inputs: Field_BedsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lits`)
};

const de_field_beds = /** @type {(inputs: Field_BedsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Betten`)
};

const ja_field_beds = /** @type {(inputs: Field_BedsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ベッド数`)
};

const zh_field_beds = /** @type {(inputs: Field_BedsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`床位`)
};

const ar_field_beds = /** @type {(inputs: Field_BedsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الأسرة`)
};

const id_field_beds = /** @type {(inputs: Field_BedsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tempat Tidur`)
};

const it_field_beds = /** @type {(inputs: Field_BedsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Letti`)
};

const ru_field_beds = /** @type {(inputs: Field_BedsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Кровати`)
};

const pt_field_beds = /** @type {(inputs: Field_BedsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Camas`)
};

const ko_field_beds = /** @type {(inputs: Field_BedsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`침대`)
};

/**
* | output |
* | --- |
* | "Beds" |
*
* @param {Field_BedsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const field_beds = /** @type {((inputs?: Field_BedsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_BedsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_beds(inputs)
	if (locale === "es") return es_field_beds(inputs)
	if (locale === "fr") return fr_field_beds(inputs)
	if (locale === "de") return de_field_beds(inputs)
	if (locale === "ja") return ja_field_beds(inputs)
	if (locale === "zh") return zh_field_beds(inputs)
	if (locale === "ar") return ar_field_beds(inputs)
	if (locale === "id") return id_field_beds(inputs)
	if (locale === "it") return it_field_beds(inputs)
	if (locale === "ru") return ru_field_beds(inputs)
	if (locale === "pt") return pt_field_beds(inputs)
	return ko_field_beds(inputs)
});